module.exports = __webpack_public_path__ + "img/dsp-2-sm.ea57cf7a.jpg";